<template>
    <div>
        <h3 class="text-center mt-4 mb-3"
            v-html="jsonObjectClubUnion.clubUnionHead"></h3>
        <ul>
            <li v-html="jsonObjectClubUnion.clubs.club1.clubName"></li>
            <li v-html="jsonObjectClubUnion.clubs.club2.clubName"></li>
        </ul>
    </div>
</template>

<script>
import jsonObjectClubUnion from './ClubUnion.json';
export default {
    data(){
        return {
            jsonObjectClubUnion,
        }
    }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/EN-vers/menu/ClubUnion.vue